import React from 'react'
import theme from './RadioButtonGroupWithTooltips.scss'
import { RadioGroup } from 'common/styleguide/RadioGroup'
import { WithTooltip } from 'common/styleguide/WithTooltip'
import { Icon } from 'common/Icon'

const disableOverflow = {
  modifiers: {
    preventOverflow: {
      boundariesElement: document.body
    }
  }
}

export class RadioButtonGroupWithTooltips extends React.PureComponent {
  render () {
    const { options, tooltips, onChange, name, selected, tooltipOptions } = this.props
    const mungedOptions = options.map((v, k) => (
      <div key={k} className={theme.labelText}>
        <span>{v}</span>
        <div className={theme.tooltipIcon}>
          <WithTooltip {...tooltipOptions} popperOptions={disableOverflow}>
            <Icon title={tooltips.get(k)} i={'help-circled'} />
          </WithTooltip>
        </div>
      </div>
    ))
    return <RadioGroup theme={theme} options={mungedOptions} name={name} onChange={onChange} selected={selected} />
  }
}
